<template>
  <div v-loading="loading" class="compact-container">
    <el-card class="filter-card" shadow="never">
      <div class="filter-title">查詢條件</div>
      <el-form :model="queryParams" label-width="150px" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="開始時間">
              <el-date-picker
                v-model="queryParams.startMs"
                type="datetime"
                placeholder="選擇開始時間"
                value-format="timestamp"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="結束時間">
              <el-date-picker
                v-model="queryParams.endMs"
                type="datetime"
                placeholder="選擇結束時間"
                value-format="timestamp"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="不變次數門檻">
              <el-input-number
                v-model="queryParams.min_run"
                :min="1"
                :max="1000"
                placeholder="預設 10"
                style="width: 100%"
              />
              <span class="input-tip">數據水平不變達此次數才列出</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="NAN 比重門檻 (%)">
              <el-input-number
                v-model="queryParams.nan_ratio_threshold"
                :min="0"
                :max="100"
                :precision="1"
                placeholder="預設 10"
                style="width: 100%"
              />
              <span class="input-tip">NAN 佔一天比重超過此值才列出</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button size="small" @click="resetParams">重置</el-button>
            <el-button type="primary" size="small" @click="getAbnormalFeatures">查詢</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <div class="table-section">
      <h3 class="section-title">數據水平不變異常</h3>
      <el-table
        :data="consecutiveEqualIssue"
        style="width: 100%"
        size="small"
        :header-cell-style="{ background: '#f5f7fa', padding: '6px 0' }"
        :cell-style="{ padding: '6px 10px' }"
      >
        <el-table-column
          prop="name"
          label="儀器名稱"
          width="250"
        >
          <template #default="{ row }">
            <a :href="'/chart?instrument=' + row.instrumentId + '&autoRun=true&autoTable=true'"
              target="_blank">
              {{ row.name }}
            </a>
            <!--router-link :to="{ name: 'chart', query: { instrument: row.data.instrumentId, autoRun: true, autoTable: true } }" target="_blank" class="button inform-btn">chart</router-link-->
          </template>
        </el-table-column>
        <el-table-column
          prop="consecutiveEqualCount"
          label="不變次數"
          width="100"
          align="center"
        />
        <el-table-column
          prop="consecutiveEqualMaxDate"
          label="最大時間點"
          width="240"
        />
        <el-table-column
          prop="consecutiveEqualMaxCount"
          label="最大累積次數"
          width="120"
          align="center"
        />
      </el-table>
    </div>

    <div class="table-section">
      <h3 class="section-title">NAN 超標異常</h3>
      <el-table
        :data="nanByDayIssus"
        style="width: 100%"
        size="small"
        :header-cell-style="{ background: '#f5f7fa', padding: '6px 0' }"
        :cell-style="{ padding: '6px 10px' }"
      >
        <el-table-column
          prop="name"
          label="儀器名稱"
          width="250"
        >
          <template #default="{ row }">
            <a :href="'/chart?instrument=' + row.instrumentId + '&autoRun=true&autoTable=true'"
              target="_blank">
              {{ row.name }}
            </a>
            <!--router-link :to="{ name: 'chart', query: { instrument: row.data.instrumentId, autoRun: true, autoTable: true } }" target="_blank" class="button inform-btn">chart</router-link-->
          </template>
        </el-table-column>
        <el-table-column
          prop="nanByDayCount"
          label="超標天數"
          width="100"
          align="center"
        />
        <el-table-column
          prop="nanByDayStartDate"
          label="起點日期"
          width="120"
        />
        <el-table-column
          prop="nanByDayEndDate"
          label="終點日期"
          width="120"
        />
        <el-table-column
          prop="maxNANByDayCount"
          label="最大NAN計數"
          width="120"
          align="center"
        />
      </el-table>
    </div>

    <div class="table-section">
      <h3 class="section-title">TI 突波</h3>
        <el-table
        :data="tiNoiseCheck"
        style="width: 100%"
        size="small"
        :header-cell-style="{ background: '#f5f7fa', padding: '6px 0' }"
        :cell-style="{ padding: '6px 10px' }"
      >
        <el-table-column
          prop="name"
          label="儀器名稱"
          width="250"
        >
          <template #default="{ row }">
            <a :href="'/chart?instrument=' + row.instrumentId + '&autoRun=true&autoTable=true'"
              target="_blank">
              {{ row.name }}
            </a>
            <!--router-link :to="{ name: 'chart', query: { instrument: row.data.instrumentId, autoRun: true, autoTable: true } }" target="_blank" class="button inform-btn">chart</router-link-->
          </template>
        </el-table-column>
        <el-table-column
          prop="timestamp"
          label="突波時間點"
          width="250"
          align="center"
        />
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectedProject: '',
      data: null,
      consecutiveEqualIssue: [],
      nanByDayIssus: [],
      tiNoiseCheck: [],
      
      queryParams: {
        startMs: null,
        endMs: null,
        min_run: 10,
        nan_ratio_threshold: 10,
      },

      loading: true,
    };
  },
  mounted(){
    this.selectedProject = this.$store.state.project.selectedProject._id;
    this.initDefaultTime();
    this.getAbnormalFeatures();
  },
  methods: {
    initDefaultTime() {
      const DAY = 24 * 60 * 60 * 1000;
      let now = Date.now();

      // 預設結束時間為現在
      this.queryParams.endMs = now;
      // 預設開始時間為 7 天前
      let startMs = (now - 7 * DAY);
      startMs = this.toMsOrUndef((new Date(startMs)).setHours(0, 0, 0, 0));
      this.queryParams.startMs = startMs;
    },
    toMsOrUndef(v) {
      if (v === undefined || v === null || v === '') return undefined;
      const n = Number(v);
      return Number.isFinite(n) ? n : undefined;
    },
    resetParams() {
      this.queryParams.min_run = 10;
      this.queryParams.nan_ratio_threshold = 10;
      this.initDefaultTime();
    },
    async getAbnormalFeatures() {
      this.loading = true;

      // 建立查詢參數
      const params = {
        startMs: this.queryParams.startMs,
        endMs: this.queryParams.endMs,
        min_run: this.queryParams.min_run,
        nan_ratio_threshold: this.queryParams.nan_ratio_threshold / 100, // 轉換為小數
      };

      const res = await this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.selectedProject}/checkInstrumentFeatureAnalysis`,
        params,
      });

      this.data = res.data;
      console.log(this.data);
      if(this.data){
        this.consecutiveEqualIssue = this.data.filter(ele=>{
          return ele.consecutiveEqual.hasIssue;
        }).map(ele=>{
          let maxRun = ele.consecutiveEqual.runs.sort((a, b)=> (b.length ?? 0) - (a.length ?? 0))[0];
          return {
            name: ele.name,
            consecutiveEqualCount: ele.consecutiveEqual.runCount,
            consecutiveEqualMaxDate: maxRun.startTs,
            consecutiveEqualMaxCount: maxRun.length,
            data: ele.consecutiveEqual,
            instrumentId: ele.instrumentId,
          };
        });
        this.nanByDayIssus = this.data.filter(ele=>{
          return ele.nanByDay.days.filter(day=>day.hit).length > 0;
        }).map(ele=>{
          const days = ele.nanByDay.days.filter(d => d.hit);
          return {
            name: ele.name,
            nanByDayCount: days.length,
            nanByDayStartDate: days[0].day,
            nanByDayEndDate: days[days.length - 1].day,
            maxNANByDayCount: days.sort((a, b)=> (b.invalid ?? 0) - (a.invalid ?? 0))[0].invalid,
            data: ele.nanByDay,
            instrumentId: ele.instrumentId,
          };
        });

        this.tiNoiseCheck = this.data.filter(ele=>{
          return ele.tiNoiseCheck.hasIssue.length > 0;
        }).reduce((pre, cur)=>{
          for(let check of cur.tiNoiseCheck.hasIssue){
            pre.push(
              {
                name: cur.name,
                instrumentId: cur.instrumentId,
                timestamp: this.$moment(check.TIMESTAMP).tz('Asia/Taipei').format('YYYY-MM-DD HH:mm'),
                reading: check.reading2,
              },
            );
          }
          return pre;
        },[]).sort((a, b)=>{
          return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
        });
      }

      console.log(this.consecutiveEqualIssue.length);
      console.log(JSON.stringify(this.consecutiveEqualIssue, null, 2));
      console.log(this.nanByDayIssus.length);
      console.log(JSON.stringify(this.nanByDayIssus, null, 2));
      console.log(this.tiNoiseCheck.length);
      console.log(JSON.stringify(this.tiNoiseCheck, null, 2));

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.compact-container {
  padding: 10px;
  font-size: 13px;
}

.table-section {
  margin-bottom: 20px;
}

.section-title {
  margin: 0 0 8px 0;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  background-color: #e4f0f5;
  border-left: 3px solid #409eff;
}

/* 覆寫 Element UI 表格樣式 */
:deep(.el-table) {
  font-size: 13px;
}

:deep(.el-table th) {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

:deep(.el-table td) {
  font-size: 13px;
}

:deep(.el-table--small .el-table__cell) {
  padding: 6px 0;
}

:deep(.el-table thead) {
  color: #606266;
}

/* 斑馬紋效果 */
:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: #f5f7fa;
}

:deep(.el-table__body tr:nth-child(even)) {
  background-color: #fafafa;
}

/* 移除表格外邊框使其更緊密 */
:deep(.el-table--border) {
  border: none;
}

:deep(.el-table--border::after),
:deep(.el-table--border::before) {
  background-color: transparent;
}
</style>